define(['../appContext', '../utils/tools'],
function (app, tools) {
    "use strict";

    var t = {};

    t.allTags = new tools.dictionary();


    t.getAllTags = function (callback) {
        var reqData = {
            Session: app.dv.cache.session.sessionGUID,
        }

        services.call(services.endpoints.getAllTags, reqData, function (results) {
            if (callback != null) {
                callback(results);
            }
        });

    }

    t.getTagByUID = function (UID) {
        var td = t.allTags.Values;
        for (var ti = 0, tl = td.length; ti < tl; ti++) {
            var tag = td[ti];
            if (tag.UID == UID) {
                return tag;
            }
        }
        return null;
    }

    t.getTagByName = function (name) {
        var td = t.allTags.Values;
        for (var ti = 0, tl = td.length; ti < tl; ti++) {
            var tag = td[ti];
            if (tag.Name == name || tag.Definition.Name == name) {
                return tag;
            }
        }
        return null;
    }

    //TagLinks...KB

    t.allTagLinks = new tools.dictionary();

    t.getAllTagLinks = function (callback) {
        var reqData = {
            Session: app.dv.cache.session.sessionGUID,
        }

        services.call(services.endpoints.getAllTagLinks, reqData, function (results) {
            if (callback != null) {
                callback(results);
            }
        });

    }

    t.getTagLinkByUID = function (UID) {
        var tld = t.allTagLinks,
            index = tld.KeysUID.indexOf(UID);
        if (index != -1) {
            return tld.Values[index];
        }
        else {
            return null;
        }
    }

    t.getTagLinkByEntityUID = function (entityUID, tagUID) {
        var tld = t.allTagLinks.Values;
        for (var tli = 0, tll = tld.length; tli < tll; tli++) {
            var tagLink = tld[tli];
            if (tagLink.EntityUID == entityUID && tagLink.TagUID == tagUID) {
                return tagLink;
            }
        }
        return null;
    }

    t.getAllTagLinksByEntityUID = function (entityUID) {
        var tld = t.allTagLinks.Values,
            entityTagLinks = [];
        for (var tli = 0, tll = tld.length; tli < tll; tli++) {
            var tagLink = tld[tli];
            if (tagLink.EntityUID == entityUID) {
                entityTagLinks.push(tagLink);
            }
        }
        return entityTagLinks;
    }

    t.getAllTagLinksByTagUID = function (tagUID) {
        var tld = t.allTagLinks.Values,
            tagUIDTagLinks = [];
        for (var tli = 0, tll = tld.length; tli < tll; tli++) {
            var tagLink = tld[tli];
            if (tagLink.TagUID == tagUID) {
                tagUIDTagLinks.push(tagLink);
            }
        }
        return tagUIDTagLinks;
    }

    t.applyClientProperties = function (entity) {
        if (entity == null) { return; }
        entity.clientProperties = new app.dv.entities.ClientProperties(app.dv.types.EntityTypes.Tag);
        entity.clientProperties.taggedEntities = new tools.dictionary();
    };

    return t;
});
